module.exports = __webpack_public_path__ + "img/banner-5.e373069d.jpg";